import { Component, OnInit, input, viewChild } from '@angular/core';
import { UI_LOADER } from '@maximizer/core/shared/ui/components/loader';
import {
  AbEntryService,
  LeadService,
  OutlookStore,
} from '@maximizer/outlook/shared/data-access';
import {
  EntryType,
  OutlookAbEntryDetails,
  OutlookLeadSearch,
} from '@maximizer/outlook/shared/domain';
import {
  OUTLOOK_SHARED_UI,
  OutlookNotificationComponent,
} from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, finalize } from 'rxjs';

@Component({
  selector: 'maximizer-entry-details',
  templateUrl: './entry-details.component.html',
  imports: [OUTLOOK_SHARED_UI, TranslatePipe, UI_LOADER],
})
export class EntryDetailsComponent implements OnInit {
  notification = viewChild<OutlookNotificationComponent>('notification');

  type = input<string>();
  id = input('', { transform: (v: string) => decodeURI(v) });

  isCompany = false;
  isContact = false;
  abentry?: OutlookAbEntryDetails;
  lead?: OutlookLeadSearch;
  loading = true;
  EntryType = EntryType;

  constructor(
    private readonly abentryService: AbEntryService,
    private readonly leadService: LeadService,
    public outlookStore: OutlookStore,
  ) {}

  ngOnInit(): void {
    if (this.type() === 'lead') {
      this.leadService
        .getByKey(this.id())
        .pipe(
          catchError(() => {
            this.notification()?.show('load', 'error');
            return [];
          }),
          finalize(() => {
            this.loading = false;
          }),
        )
        .subscribe((data) => {
          if (data) {
            this.lead = data;
          }
        });
    }

    if (this.type() === 'abentry') {
      this.abentryService
        .getAllDetailsByKey(this.id())
        .pipe(
          catchError(() => {
            this.notification()?.show('load', 'error');
            return [];
          }),
          finalize(() => {
            this.loading = false;
          }),
        )
        .subscribe((data) => {
          if (data) {
            if (data.type === EntryType.Company) {
              this.isCompany = true;
            } else if (data.type === EntryType.Contact) {
              this.isContact = true;
            }
            this.abentry = data;
          }
        });
    }
  }

  getAddress(): string {
    const entry = this.abentry || this.lead;
    if (entry?.address) {
      const address = entry.address;
      return `${address.address1} ${address.address2}\n${address.city} ${address.provinceState} ${address.zipcode}\n${address.country}`.trim();
    }
    return '';
  }
}
